export default __webpack_public_path__ + "static/media/Slide3.9926a825.PNG";